module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABGdBTUEAALGPC/xhBQAAAT1JREFUKBVjZACClStXxjMxMRn9////NjMz869///4JA9maQKl3QPohIyPjbyAGiwHly4ODgx+y7Ny5k/vTp0/hQEWcQEk9oCaQWQxANoiSBdL6IAYIgMT+/PkTDWS2MX3+/NkVyOAESRADgC5z2LhxIy8L0CncQFuOEKMJpubv37/yLNzc3Lu+fPmyFyZIDM3GxvaTBahpGdDtLMRogKn59u3bLSYgBxIaMFEiaKBF/5mAxBMi1KIrecIEDJwz6KKE+CA9IKeuBzJ+E1IMkweqfcPDw7OfKSws7AXQuVNhEvhooKZ/wJTT5eXl9RNkI0NoaOhGoOZZBDSBXNUKTG6nQerA6QqmYdWqVQZAAwqAfHmYGIgG2nQFaFM/UNM9mDiKRqgipvXr11sBU5MHMIV8A0b2tsDAwAswDTAaAO2tgFXhxIIHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/List/icon-highway.png
// module id = 1466
// module chunks = 0